import { render, staticRenderFns } from "./StrengthsPage.vue?vue&type=template&id=f4c36756&scoped=true&"
import script from "./StrengthsPage.vue?vue&type=script&lang=js&"
export * from "./StrengthsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c36756",
  null
  
)

export default component.exports